var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['comp-content', _vm.component.active ? 'active' : ''],style:(_vm.getStyle)},[_c('div',{staticClass:"search-box",style:({
      flexDirection: _vm.iconPosition ? 'row' : 'row-reverse',
      borderRadius: (_vm.getSearchBoxHeight / 2) + 'px'
    })},[_c('input',{staticClass:"search_input",style:({
        height: _vm.getSearchBoxHeight + 'px',
        borderRadius: (_vm.getSearchBoxHeight / 2) + 'px'
      }),attrs:{"readonly":"","type":"text","placeholder":"please enter..."}}),_c('i',{staticClass:"el-icon-search"})])])}
var staticRenderFns = []

export { render, staticRenderFns }